<template>
  <div>
    <div class="bg">
      <div class="bgImg">
        <div class="pageTitle">办学单位</div>
        <img src="@/assets/img/bjing@2x.png" alt="" />
      </div>
    </div>
    <div class="educateInstitute">
      <div class="stepTitle">
        <span v-for="item in educateTitle" :key="item.value" :class="activeStep == item.value ? 'isActive' : ''" @click="changeStep(item.value)">{{ item.title }}</span>
      </div>
      <ul class="lists">
        <li v-for="(item,index) in listData" :key="index" @click="goDetails(item.schoolId)">
          <!-- <span>{{ item.newsName }}</span> -->
          <span>{{ item.schoolName }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {getSchoolByLevel,couschoolGetSchoolList} from '@/api/schoolInfo'
export default {
  name: "educateInstitute",
  data() {
    return {
      activeStep: '2',
      listData: [],
      educateTitle: [
        {
          title: '合作办学单位',
          value: '2'
        },
        {
          title: '分校',
          value: '1'
        }
      ],
    };
  },
  props: [],

  created(){
    this.initRequest()
  },
  methods: {
    changeStep(value) {
      this.listData = []
      this.activeStep = value
      this.initRequest()
    },
    initRequest() {
      const querys = {
        "attributeNamesForOrderBy": "",
        "pageNo": 1,
        "pageSize": 100,
        "params": {
          "isTvUniversity": this.activeStep
        }
      }
      couschoolGetSchoolList(querys).then(res=>{
        this.listData = res.list
      })
    },
    goDetails(id) {
      this.$router.push({name: 'schoolDetails',query: {id}})
    }
  },
};
</script>
<style scoped>
/* 背景图片 */
.bgImg {
  position: relative;
  width: 100%;
  height: 272px;
  z-index: 0;
}
.bgImg img {
  width: 100%;
  height: 100%;
}
.bgImg .pageTitle {
  position: absolute;
  top: 82px;
  left: 26px;
  font-size: 25px;
  font-weight: bold;
  color: #FFFFFF;
}
.appName {
  width: 171px;
  background-color: #ffffff4b;
  text-align: center;
  height: 24px;
  line-height: 24px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  top: 104px;
  left: 50%;
  transform: translate(-50%, 0);
}

.educateInstitute {
  overflow-y: scroll;
  position: relative;
  top: -138px;
  height: calc(100vh - 138px);
  line-height: 25px;
  font-size: 14px;
  margin: 0 9px 10px;
  border-radius: 8px;
  background-color: #ffffff;
}
.educateInstitute .title {
  
}
.stepTitle {
  display: flex;
}
.stepTitle span {
  width: 197px;
  height: 53px;
  text-align: center;
  line-height: 53px;
  border-radius: 7px 7px 0px 0px;
}
.isActive {
  background: linear-gradient(180deg, #FFC5C2 0%, rgba(255,255,255,0) 100%);
}
.lists {
  padding-left: 25px;
  list-style-type: disc;
  height: calc(100vh - 60px);
  overflow-y: scroll;
  color: #D02B3A;
}
.lists span {
  color: #333;
}
</style>